"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateCreateRequestSchema = exports.StateObjectSchema = void 0;
const zod_1 = require("zod");
const workflow_1 = require("../workflow");
const workspace_1 = require("../workflow/workspace");
exports.StateObjectSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    object: zod_1.z.literal('state'),
    created_at: zod_1.z.date().openapi({ format: 'date-time' }),
})
    .openapi('StateObject');
// Create
exports.StateCreateRequestSchema = zod_1.z
    .discriminatedUnion('type', [
    zod_1.z
        .object({
        type: zod_1.z.literal('task'),
        data: workflow_1.WorkflowTaskInputSchema,
    })
        .openapi('StateCreateTaskRequest'),
    zod_1.z
        .object({
        type: zod_1.z.literal('form'),
        data: workflow_1.WorkflowTaskInputSchema,
    })
        .openapi('StateCreateFormRequest'),
    zod_1.z
        .object({
        type: zod_1.z.literal('form_v2'),
        data: workflow_1.WorkflowFormInputSchema,
    })
        .openapi('StateCreateFormV2Request'),
    zod_1.z
        .object({
        type: zod_1.z.literal('workspace'),
        data: workspace_1.WorkflowWorkspaceFormInputSchema,
    })
        .openapi('StateCreateWorkspaceRequest'),
])
    .openapi('StateCreateRequest');
//# sourceMappingURL=stateSchema.js.map